<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div>
          {{ $t("policy.compliance-acceptance.text") }}:

          <select class="form-control" v-model="form.acceptance" :disabled="isAcceptanceDisabled">
            <option disabled value="UNWORKED">{{ this.$t("policy.compliance-acceptance.unworked") }}</option>
            <!-- Varsayılan seçeneği ekleyin -->
            <option v-for="item in productBasedFilteredOptions" :key="item.definition" :value="item.definition">{{ item.text }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div v-if="showTargetComplianceStatus">
          {{ $t("policy.compliance-acceptance.target") }}:
          <select class="form-control " v-model="form.targetAcceptance" :disabled="disabled">
            <option disabled value="UNWORKED">{{ this.$t("policy.compliance-acceptance.unworked") }}</option>
            <option v-for="item in targetComplianceStatusOptions" :key="item.definition" :value="item.definition">{{ item.text }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div v-if="showCalendar">
          {{ $t("policy.acceptance-date") }}:
          <date-picker
            :disabled="disabled"
            v-model="form.acceptanceDate"
            :disabled-date="(date) => date > new Date()"
            :first-day-of-week="1"
            :lang="currentLanguage"
            format="DD.MM.YYYY"
            value-type="timestamp"
            :placeholder="$t('policy.acceptance-date')"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <div class="text-right">
            <sweet-button v-if="isSaveButtonVisible" @click="save(policy._id)" :disabled="disabled" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
              {{ $t("common.save") }}
            </sweet-button>
          </div>
        </div>
        <PolicyComplianceStatusDescription :disabled="disabled" :policy="policy" :complianceStatus="complianceStatus" />
        <div class="text-right" v-if="!disabled"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

import PolicyComplianceStatusDescription from "./policy-compliance-status-description";
import PolicyStatus from "./policy-status";

export default {
  props: ["policy", "complianceStatus", "showText", "createMode", "disabled"],
  components: {
    PolicyStatus,
    PolicyComplianceStatusDescription,
    DatePicker,
  },
  computed: {
    productBasedFilteredOptions() {
      const products = ["BGYS", "DDO"];
      if (this.policy.compliances.some((c) => products.includes(c.product))) {
        return this.options;
      } else {
        return this.options.filter(({ definition }) => ["COMPLETELY", "NOT_APPLICABLE", "NEVER"].includes(definition));
      }
    },
    selected() {
      return this.selectedAcceptance;
    },
    isAcceptanceDisabled() {
      return this.disabled || (this.complianceStatus.acceptance != "UNWORKED" && this.complianceStatus.acceptance != "NOT_APPLICABLE" && this.complianceStatus.startedDate);
    },
    showCalendar() {
      if (this.complianceStatus.startedDate && this.policy?.status != "WAITING_FOR_ASSESSMENT") {
        return false;
      }

      return (
        ((this.selectedAcceptance == "COMPLETELY" && this.complianceStatus.acceptance != this.selectedAcceptance) ||
          (this.selectedAcceptance == "NOT_APPLICABLE" && this.complianceStatus.acceptance != this.selectedAcceptance) ||
          (this.selectedTargetAcceptance == this.selectedAcceptance &&
            this.selectedAcceptance != this.complianceStatus.selectedAcceptance &&
            this.selectedTargetAcceptance != this.complianceStatus.targetAcceptance &&
            this.selectedTargetAcceptance != "UNWORKED")) &&
        (this.complianceStatus.acceptance != this.selectedAcceptance || this.complianceStatus.targetAcceptance != this.targetAcceptance)
      );
    },
    showTargetComplianceStatus() {
      return this.form.acceptance && this.form.acceptance != "UNWORKED";
    },
    isSaveButtonVisible() {
      if (this.policy.status == "WAITING_FOR_ASSESSMENT") {
        return false;
      }
      if (this.form.acceptance == this.complianceStatus.acceptance && this.form.targetAcceptance == this.complianceStatus.targetAcceptance) {
        return false;
      }

      // if (this.form.acceptance == this.form.targetAcceptance) {
      //   if (this.form.acceptanceDate) {
      //     return true;
      //   }
      //   return false;
      // }
      else {
        if (this.form.acceptance != "UNWORKED" && this.form.targetAcceptance != "UNWORKED") {
          return true;
        }
        return false;
      }

      return this.form.acceptance != "UNWORKED" && this.form.targetAcceptance != "UNWORKED";
    },

    modalId() {
      return this.unique + (this.policy ? this.policy._id + this.compliance.definitionId + "acceptance-date-modal" : "acceptance-date-modal");
    },
  },

  data() {
    return {
      form: {
        id: undefined,
        conditionDefinitionId: undefined,
        acceptance: undefined,
        targetAcceptance: undefined,
        acceptanceDate: undefined,
        no: undefined,
      },
      oldValue: undefined,
      acceptanceDate: undefined,
      processSuccess: false,
      selectedAcceptance: "UNWORKED",
      selectedTargetAcceptance: "UNWORKED",
      tempCompliance: this.compliance ? { ...this.compliance } : {},
      unique: undefined,
      options: [
        {
          definition: "COMPLETELY",
          text: this.$t("policy.compliance-acceptance.completely"),
        },
        {
          definition: "MOSTLY",
          text: this.$t("policy.compliance-acceptance.mostly"),
        },
        {
          definition: "PARTIAL",
          text: this.$t("policy.compliance-acceptance.partial"),
        },
        {
          definition: "NEVER",
          text: this.$t("policy.compliance-acceptance.never"),
        },
        {
          definition: "NOT_APPLICABLE",
          text: this.$t("policy.compliance-acceptance.not-applicable"),
        },
      ],
      targetComplianceStatusOptions: [],
    };
  },
  watch: {
    complianceStatus: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) return;
        this.form = {
          id: this.policy._id,
          conditionDefinitionId: v.definitionId,
          acceptance: v.acceptance,
          targetAcceptance: v.targetAcceptance,
          acceptanceDate: v.acceptanceDate,
          no: v.no,
        };
        // this.form = { ...this.prepareFormForEdit(v) };
      },
    },
    "form.acceptance": {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) {
          return;
        } else {
          if (v && v == "COMPLETELY") {
            this.form.targetAcceptance = "COMPLETELY";
          }
          if (v && v == "NOT_APPLICABLE") {
            this.form.targetAcceptance = "NOT_APPLICABLE";
          }
          if (v && v == "NEVER" && this.targetComplianceStatusOptions.length == 1 && this.targetComplianceStatusOptions[0].definition == "COMPLETELY") {
            this.form.targetAcceptance = "COMPLETELY";
          }
          this.selectedAcceptance = v;
          this.targetComplianceStatusOptions = this.calculateTargetOptions();
        }
      },
    },
    "form.targetAcceptance": {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) {
          return;
        } else {
          this.selectedTargetAcceptance = v;
        }
      },
    },
  },
  mounted() {
    this.unique = new Date().getTime();
    // this.selectedAcceptance = this.compliance.acceptance;
    // this.selectedTargetAcceptance = this.compliance.targetAcceptance;
  },
  methods: {
    getFormData() {
      return this.form;
    },
    calculateTargetOptions() {
      let opts = this.productBasedFilteredOptions;

      if (this.form.acceptance == "COMPLETELY") {
        return opts.filter((i) => i.definition == "COMPLETELY");
      } else if (this.form.acceptance == "PARTIAL") {
        return opts.filter((i) => ["PARTIAL", "MOSTLY", "COMPLETELY"].includes(i.definition));
      } else if (this.form.acceptance == "MOSTLY") {
        return opts.filter((i) => ["MOSTLY", "COMPLETELY"].includes(i.definition));
      } else if (this.form.acceptance == "NEVER") {
        return opts.filter((i) => ["PARTIAL", "MOSTLY", "COMPLETELY"].includes(i.definition));
      } else if (this.form.acceptance == "NOT_APPLICABLE") {
        return opts.filter((i) => i.definition == "NOT_APPLICABLE");
      }

      return opts;
    },
    text(value) {
      if (value == "UNWORKED") {
        return this.$t("policy.compliance-acceptance.unworked");
      } else if (value == "COMPLETELY") {
        return this.$t("policy.compliance-acceptance.completely");
      } else if (value == "PARTIAL") {
        return this.$t("policy.compliance-acceptance.partial");
      } else if (value == "MOSTLY") {
        return this.$t("policy.compliance-acceptance.mostly");
      } else if (value == "NEVER") {
        return this.$t("policy.compliance-acceptance.never");
      } else if (value == "NOT_APPLICABLE") {
        return this.$t("policy.out-of-scope");
      }

      return this.$t("policy.compliance-acceptance.unworked");
    },

    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        this.selectedAcceptance = this.oldValue;
        return;
      }
      if (this.disabled) {
        return;
      }

      await this.$store.dispatch("organizationPolicy/updateComplianceStatus", this.form);

      await this.$store.dispatch("organizationPolicy/updateTargetComplianceStatus", this.form);
      this.processSuccess = true;

      this.$emit("onSelect", { definition: this.selectedAcceptance });
    },
  },
};
</script>
